/** Identidad de la app. Todo texto de marca sale de aquí. */
export const brand = {
  name: 'Pizarra Agro',
  tagline: 'Los precios del campo, al dólar BCV',
  shortName: 'Pizarra Agro',
  /** Texto fijo en mensajes compartidos (WhatsApp, PDF, CSV). */
  signature: 'Pizarra Agro · precios referenciales del campo venezolano',
  disclaimer:
    'Precios referenciales publicados por gremios y fuentes del sector; no son precios oficiales ni una oferta. Verifica antes de negociar.',
} as const;
